<template>
  <div class="score">
    <Loading v-if="loading" />
    <div class="bgc top_div">
      <div class="title">
        <div class="sort_son_title">
          {{ itemTitle }}
        </div>
        <!-- tabs切换 -->
        <div
          v-if="id == 'scoreLineContrast' && query.seId > 0"
          class="wrap-tab"
        >
          <a-tabs
            :active-key="tabActive"
            class="setmodel-tab"
            @change="changeTab"
          >
            <a-tab-pane
              v-for="item in selectList"
              :key="item.sType"
              :tab="item.name"
            />
          </a-tabs>
        </div>
        <div class="right_div">
          <a-button
            v-if="data && data.length"
            class="btn"
            type="primary"
            ghost
            @click="importTo"
          >
            {{ $t('exam.downbtn') + itemTitle + $t('exam.biao') }}
          </a-button>
        </div>
      </div>
      <div v-if="id == query.seId > 0" class="text_tip">
        {{ exp[tabActive] }}
      </div>
      <!-- <div v-if="data.length" class="echarts">
        <div :id="id" class="echarts_list"></div>
      </div> -->
      <NotData v-show="!data.length && !loading" />
      <Table
        v-if="data.length"
        :columns="columns"
        :pagination="false"
        :data="data"
        :custom-row="customRow"
      />
    </div>
    <!-- <div v-if="data && data.length" class="bgc table_div">
      <Table
        :columns="columns"
        :pagination="false"
        :data="data"
        :custom-row="customRow"
      />
    </div> -->
  </div>
</template>

<script>
  import axios, { getCookie } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import Loading from '@comp/loading'
  export default {
    name: 'ScoreLineContrast',
    components: {
      Table,
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      },
      cache: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        columns: [],
        columnsS: [
          {
            title: this.$t('exam.classGroup'),
            dataIndex: 'classType',
            key: 'classType',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('exam.className'),
            dataIndex: 'className',
            key: 'className',
            width: 100,
            ellipsis: true
          }
        ],
        data: [],
        tabActive: 0,
        selectList: [],
        // pagination: {
        //   pageSize: 10,
        //   total: 0,
        //   showQuickJumper: true,
        //   showSizeChanger: true,
        //   hideOnSinglePage: true,
        //   pageSizeOptions: ['10', '20', '100', '200', '500']
        // },
        // orderField: 'messGradeOrder',
        // orderType: 'asc',
        // meIds: {},
        query: {},
        exp: [
          '',
          '双上线率=双上线人数/参考人数',
          '学科命中率=双上线人数/单科上线人数',
          '学科贡献率=双上线人数/总分上线人数'
        ]
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.query.classId || this.$route.query.seId) {
            this.getTable()
          }
        },
        deep: true
      }
    },
    mounted() {
      this.query = this.$route.query
      this.getTable()
    },
    methods: {
      customRow(record) {
        let className =
          this.$route.query.classId * 1 &&
          record.classId == this.$route.query.classId
            ? 'current'
            : ''
        return className
      },
      changeTab(key) {
        this.tabActive = key
        this.getData()
      },
      // change(pagination, filters, sorter) {
      //   if (sorter.field == 'className') {
      //     sorter.field = 'classId'
      //   }
      //   this.orderField = sorter.field
      //   if (sorter.order == 'descend') {
      //     this.orderType = 'desc'
      //   } else {
      //     this.orderType = 'asc'
      //   }
      //   this.pagination.pageSize = pagination.pageSize
      //   this.getTable(pagination.current)
      // },
      getTable() {
        this.loading = true
        let { dId, meId, seId, campusId } = this.$route.query
        let params = {
          meId,
          seId,
          dId,
          campusId
        }
        axios({
          url: 'getscorelineanalysiscomparison',
          params,
          loading: false,
          getCache: this.cache,
          cacheData: false
        })
          .then(res => {
            this.loading = false
            // let pageObj = {}
            if (res.status) {
              let d = res.data
              this.selectList = res.data.lists
              d.examName.push('对比提升')
              const titleText = ['fist', 'second', 'third', 'fourth']
              // pageObj = {
              //   current: pageIndex,
              //   total: d.total
              // }
              d.lists.forEach(item => {
                item.classInfoList.forEach(ele => {
                  titleText.forEach((tit, ind) => {
                    if (ele[`${titleText[ind]}ExamData`].length) {
                      ele[`${titleText[ind]}ExamData`].forEach((val, i) => {
                        ele[`${titleText[ind]}ExamDatanum${i}`] =
                          val.num || '--'
                        ele[`${titleText[ind]}ExamDatarate${i}`] =
                          val.rate || '--'
                      })
                    }
                  })
                })
              })
              this.columns = []
              let columns2 = []
              d.fourthRateName.forEach((item, index) => {
                let obj = {
                  title: item,
                  children: []
                }
                d.examName.forEach((ele, i) => {
                  if (i == d.examName.length - 1) {
                    obj.children.push({
                      title: ele,
                      dataIndex: `${titleText[index]}ImproveRate`,
                      key: `${titleText[index]}ImproveRate`,
                      align: 'center',
                      width: 100
                    })
                  } else {
                    obj.children.push(
                      {
                        title: ele,
                        colSpan: 2,
                        dataIndex: `${titleText[index]}ExamDatanum${i}`,
                        align: 'center',
                        width: 100
                      },
                      {
                        title: ele,
                        colSpan: 0,
                        dataIndex: `${titleText[index]}ExamDatarate${i}`,
                        align: 'center',
                        width: 100
                      }
                    )
                  }
                })
                columns2.push(obj)
              })
              this.columns = [...this.columnsS, ...columns2]
              this.getData()
            } else {
              this.data = []
              // pageObj = {
              //   current: 1,
              //   total: 0
              // }
            }
            // this.pagination = {
            //   ...this.pagination,
            //   ...pageObj
            // }
          })
          .catch(() => {
            this.data = []
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      getData() {
        this.data =
          this.selectList.filter(item => item.sType == this.tabActive)[0]
            .classInfoList || []
      },
      importTo() {
        let { meId, seId, dId, campusId } = this.$route.query
        let api = ApiXy.defaulteApi.path.exportscorelineanalysiscomparison
        // let t = Date.now()
        let queryParams = {
          meId,
          seId,
          dId,
          campusId
        }
        let queryList = []
        for (let q in queryParams) {
          if (queryParams[q] !== undefined) {
            queryList.push(`${q}=${queryParams[q]}`)
          }
        }
        let url =
          `${ApiXy.defaulteApi.host}${api}?` +
          queryList.join('&') +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 4px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  /deep/.current {
    background: rgba(60, 100, 239, 0.2);
    td {
      background: none !important;
    }
  }
  /deep/.ant-tabs-ink-bar {
    display: none !important;
  }
  .score {
    height: 100%;
    // Tab切换
    .wrap-tab {
      height: 30px;
      overflow: hidden;
      flex: 1;
      .setmodel-tab {
        /deep/.ant-tabs-bar {
          border: none;
          .ant-tabs-tab {
            height: 30px;
            line-height: 30px;
            min-width: 88px;
            border-radius: 15px;
            padding: 0 16px;
            margin-right: 8px;
            font-weight: 400;
            color: #4e5969;
            font-size: @font-size-base;
          }
          .ant-tabs-tab-active {
            border: none;
            background: #f2f3f8;
            color: @primary-color;
          }
        }
      }
    }

    .top_div {
      min-height: 400px;
      margin-bottom: @padding-sm;
      .text_tip {
        margin-bottom: 10px;
      }
    }
    // .echarts {
    //   .echarts_list {
    //     width: 100%;
    //     min-height: 400px;
    //   }
    // }
    .not_data_box {
      padding: 20px 0;
    }
    // .table_div {
    //   margin-top: 12px;
    // }
  }
</style>
